module.exports = __webpack_public_path__ + "img/horizontal_6_3_9016.c2d23a34.png";